import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';

/**
 * for this page
 */
class TabNav extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
        curUrl: PropTypes.string,
    };

    state = {
        content: [
            {
                title: '新股申购',
                url: '/newStock/purchase',
            },
            {
                title: '新股日历',
                url: '/newStock/calendar',
            },
            {
                title: '新股上会',
                url: '/newStock/shanghui',
            },
            {
                title: '首发申报',
                url: '/newStock/declare',
            },
        ],
        curIndex: 0,
    };

    static getDerivedStateFromProps = (props, state) => {
        let resCon = {};

        if (props.content !== state.content) {
            resCon = { content: props.content };
        }

        return { ...resCon };
    };

    componentDidMount = () => {
        // const pathname = window.location.pathname;
        const pathname = this.props.curUrl || window.location.pathname;

        this.props.content.forEach((item, index) => {
            if (pathname === item.url) {
                this.setState({
                    curIndex: index,
                });
            }
        });
    };

    render() {
        const { content, curIndex } = this.state;

        return (
            <div className={styles.tabNav}>
                {content &&
                    content.length &&
                    content.map((item, index) => {
                        return (
                            <a
                                href={item.url}
                                className={`${styles.link} ${index === curIndex ? styles.active : ''}`}
                                key={index}>
                                {item.title}
                            </a>
                        );
                    })}
            </div>
        );
    }
}

export default TabNav;
